import { render } from "./FlagIcon.vue?vue&type=template&id=30fab01c&scoped=true"
import script from "./FlagIcon.vue?vue&type=script&lang=js"
export * from "./FlagIcon.vue?vue&type=script&lang=js"

import "./FlagIcon.vue?vue&type=style&index=0&id=30fab01c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fab01c"]])

export default __exports__